import React from "react";
import styled from "styled-components";
import media from "styled-media-query";

// Styles
import { getFontWeight } from "../../../styles/font-weight";
import { colors } from "../../../styles/colors";

// Assets
import eatingGifWeb from "../../../assets/gif/eating.gif";
import eatingGifMobile from "../../../assets/gif/eating__mobile.gif";

export const FirstSection = () => {
  return (
    <StyledDivFirstSection id="first-section-container">
      <StyledImgLogo src={require("../../../assets/images/logo-no-background.png")} />
      <StyledDivTitleAndDesc>
        <StyledDivTitle>Crystal Treats</StyledDivTitle>
        <StyledDivDesc>Japanese Delicacies with surprise experience</StyledDivDesc>
      </StyledDivTitleAndDesc>
      <StyledDivLink2Shopify>
        <StyledLinkTag href="https://misaky.tokyo/collections/frontpage">Shop Now</StyledLinkTag>
      </StyledDivLink2Shopify>
    </StyledDivFirstSection>
  );
};

const StyledDivFirstSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${media.lessThan("medium")`
    height: 100vh;
    background: url(${eatingGifMobile});
    background-size: cover;
  `};

  ${media.greaterThan("medium")`
    height: 500px;
    background: url(${eatingGifWeb});
    background-size: cover;
  `};
`;

const StyledImgLogo = styled.img`
  position: absolute;

  top: 16px;
  left: 16px;

  ${media.lessThan("small")`
    height: 30px;
  `};

  ${media.greaterThan("medium")`
    height: 55px;
  `};
`;

const StyledDivTitleAndDesc = styled.div`
  width: 100%;
  color: ${colors.white};
  text-align: center;
`;

const StyledDivTitle = styled.div`
  ${getFontWeight("Heavy")};

  ${media.lessThan("small")`
    font-size: 30px;
  `};

  ${media.greaterThan("medium")`
    font-size: 55px;
  `};
`;

const StyledDivDesc = styled.div`
  margin-top: 8px;
  font-size: 16px;
`;

const StyledDivLink2Shopify = styled.div`
  margin-top: 32px;
  ${getFontWeight("Light")};
  background-color: ${colors.blue__low_opacity};

  ${media.lessThan("small")`
    width: 200px;
    padding: 4px, 0px;
    font-size: 25px;
  `};

  ${media.greaterThan("medium")`
    width: 380px;
    padding: 5px;
    font-size: 35px;
  `};
`;

const StyledLinkTag = styled.a`
  display: block;
  text-align: center;
  color: ${colors.white};
  text-decoration: none;
`;
